import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  invoices: 'Invoices',
  invoicePayments: 'InvoicePayments',
  outboundTickets: 'OutboundTickets',
  customerInvoices: 'CustomerInvoices',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.invoicePayments, TAG_TYPES.customerInvoices],
  endpoints: {
    getInvoicePayment: {
      providesTags: (result, error, paymentId) => [{ type: TAG_TYPES.invoicePayments, id: paymentId }],
    },
    getInvoicePayments: {
      providesTags: result =>
        result && result.length > 0
          ? [
              ...result.map(payment => ({
                type: TAG_TYPES.invoicePayments,
                id: payment.id,
              })),
              { type: TAG_TYPES.invoicePayments, id: 'LIST' },
            ]
          : [{ type: TAG_TYPES.invoicePayments, id: 'LIST' }],
    },
    deleteInvoiceBulkPayment: {
      invalidatesTags: (result, error, { invoiceId, paymentId, customerId }) => [
        { type: TAG_TYPES.invoicePayments, id: 'LIST' },
        { type: TAG_TYPES.invoicePayments, id: paymentId },
        { type: TAG_TYPES.invoicePayments, id: invoiceId },
        // This makes sure to invalidate the tag for the bulk invoice payments page
        { type: TAG_TYPES.invoicePayments, id: undefined },
        { type: TAG_TYPES.invoices, id: 'LIST' },
        { type: TAG_TYPES.invoices, id: invoiceId },
        { type: TAG_TYPES.outboundTickets, id: 'LIST' },
        { type: TAG_TYPES.customerInvoices, id: customerId },
      ],
    },
    createInvoiceBulkPayment: {
      invalidatesTags: (result, error, { customerId, invoiceIds }) => {
        const invoiceTags = invoiceIds.map(invoiceId => ({
          type: TAG_TYPES.invoices,
          id: invoiceId,
        }))
        return [
          { type: TAG_TYPES.invoicePayments, id: 'LIST' },
          { type: TAG_TYPES.invoicePayments, id: undefined },
          { type: TAG_TYPES.invoices, id: 'LIST' },
          ...(invoiceTags || []),
          { type: TAG_TYPES.outboundTickets, id: 'LIST' },
          { type: TAG_TYPES.customerInvoices, id: customerId },
        ]
      },
    },
  },
})

export const {
  useGetInvoicePaymentsQuery,
  useGetInvoicePaymentQuery,
  useDeleteInvoiceBulkPaymentMutation,
  useCreateInvoiceBulkPaymentMutation,
} = api
